import { useState } from 'react'

import { UserSlice } from 'features/user/forms/UserPublisherForm/types'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_PUBLISHER, userFromDTO } from './api'
import { Data, Variables } from './api/types'
import { UseGetPublisherProps, UseGetPublisherType } from './types'

export const useGetPublisher = ({ id }: UseGetPublisherProps): UseGetPublisherType => {
  const [user, setUser] = useState<UserSlice>()

  if (id === undefined) {
    throw 'User ID is required to fetch'
  }

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async data => {
      const { node } = data

      if (node) {
        setUser(userFromDTO(node))
      }
    },
    query: GET_PUBLISHER,
    variables: { id },
  })

  return {
    loading: isLoading,
    user,
  }
}
